import { gql } from "urql";
export const CreatePostalCodeMutation = gql `
    mutation CreatePostalCode(
        $postalCode: String!
        $latitude: Float
        $longitude: Float
        $city: String!
        $stateName: String!
        $countyName: String
        $timezone: String
    ) {
        postalCodes {
            createPostalCode(
                postalCode: $postalCode
                latitude: $latitude
                longitude: $longitude
                city: $city
                stateName: $stateName
                countyName: $countyName
                timezone: $timezone
            ) {
                postalCodeId
                postalCode
                latitude
                longitude
                city
                stateId
                stateName
                countyName
                timezone
                isActive
            }
        }
    }
`;
export const UpdatePostalCodeMutation = gql `
    mutation UpdatePostalCode(
        $postalCodeId: String!
        $postalCode: String
        $latitude: Float
        $longitude: Float
        $city: String
        $stateName: String
        $countyName: String
        $timezone: String
        $isActive: Boolean
    ) {
        postalCodes {
            updatePostalCode(
                postalCodeId: $postalCodeId
                postalCode: $postalCode
                latitude: $latitude
                longitude: $longitude
                city: $city
                stateName: $stateName
                countyName: $countyName
                timezone: $timezone
                isActive: $isActive
            ) {
                postalCodeId
                postalCode
                latitude
                longitude
                city
                stateId
                stateName
                countyName
                timezone
                isActive
            }
        }
    }
`;
export const DeletePostalCodeMutation = gql `
    mutation DeletePostalCode($postalCodeId: String!) {
        postalCodes {
            deletePostalCode(postalCodeId: $postalCodeId) {
                postalCodeId
            }
        }
    }
`;
